export const buildExpendituresDictionaryByIds = (expenditures) => {
  const expendituresDictionary = {};
  expenditures.forEach((expenditure) => (expendituresDictionary[expenditure?.id] = expenditure));
  return expendituresDictionary;
};
